import React from 'react';
import { connect } from 'react-redux';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import UserPanel from '../user-panel/user-panel';
import './header.scss';
import { Template } from 'devextreme-react/core/template';

export function Header(props) {
  const { menuToggleEnabled, title, toggleMenu, activeBaseOntology, activeReport } = props;
  const baseOntologyTitle = activeBaseOntology ? activeBaseOntology.name : '';
  const reportTitle = activeReport ? ' :: ' + activeReport.title : '';
  const toolbarTitle = baseOntologyTitle + reportTitle;
  return (
    <header className={'header-component'}>
      <Toolbar className={'header-toolbar'}>
        <Item
          visible={menuToggleEnabled}
          location={'before'}
          widget={'dxButton'}
          cssClass={'menu-button'}
        >
          <Button icon="menu"
           stylingMode="text" onClick={toggleMenu} />
        </Item>
        <Item
          location={'before'}
          cssClass={'header-title'}
          text={toolbarTitle}
          visible={!!toolbarTitle}
        />
        <Item
          location={'after'}
          locateInMenu={'auto'}
          menuItemTemplate={'userPanelTemplate'}
        >
          <Button
            className={'user-button authorization'}
            width={210}
            height={'100%'}
            stylingMode={'text'}
          >
            <UserPanel menuMode={'context'} />
          </Button>
        </Item>
        <Template name={'userPanelTemplate'}>
          <UserPanel menuMode={'list'} />
        </Template>
      </Toolbar>
    </header>
)}

const mapStateToProps = (state, ownProps) => {
  return {
    activeBaseOntology: state.active.baseOntology,
    activeReport: state.active.report
  };
}

export default connect(mapStateToProps)(Header);